import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("hr", { class: "bg-gray-200 mt-5 mb-4 w-[445px] -mx-6" }, null, -1)
const _hoisted_3 = { id: "specificTypeDropdown" }
const _hoisted_4 = { class: "text-lg leading-7 font-medium text-black" }
const _hoisted_5 = { class: "flex flex-col cursor-pointer" }
const _hoisted_6 = { class: "flex justify-between border-b border-gray-200 p-3 items-center" }
const _hoisted_7 = { class: "flex justify-between p-3 items-center" }
const _hoisted_8 = { class: "text-sm leading-5 font-normal text-gray-500 pt-2" }
const _hoisted_9 = { id: "searchOverlayTarget" }
const _hoisted_10 = { class: "flex flex-col max-h-64 overflow-auto w-full top-36" }
const _hoisted_11 = { class: "relative" }
const _hoisted_12 = {
  key: 0,
  class: "py-6 border-0 px-4"
}
const _hoisted_13 = { class: "ml-3 flex items-center gap-x-2" }
const _hoisted_14 = { class: "min-w-[32px] min-h-[32px] rounded-full items-center justify-center flex" }
const _hoisted_15 = {
  key: 0,
  class: "flex justify-between items-center px-3 bg-white h-[54px] w-full rounded-b-md border-t border-gray-200"
}
const _hoisted_16 = { class: "flex items-center gap-x-4" }
const _hoisted_17 = { class: "text-base leading-6 font-medium w-fit" }
const _hoisted_18 = {
  key: 0,
  class: "flex flex-col pt-3"
}
const _hoisted_19 = { class: "flex items-center gap-x-2" }
const _hoisted_20 = { class: "min-w-[32px] min-h-[32px] rounded-full items-center justify-center flex" }

import { computed, onMounted, ref, watch } from "vue"
import { CheckIcon, MinusSmIcon, SearchIcon, TrashIcon } from "@heroicons/vue/outline"
import { useWorkflowStore } from "@/stores/workflow"
import { useAgentsStore } from "@/stores/agents"
import { useCollectionStore } from "@/stores/collection"
import { debounce } from "@/shared/utils/helpers"
import { Collection } from "@/shared/models/collection"
import { Agent } from "@/shared/models/agent"
import GgmsRadioSelect from "@/components/GgmsRadioSelect.vue"
import GgmsLoading from "@/components/GgmsLoading.vue"
import GgmsCheckBox from "@/components/GgmsCheckBox.vue"
import GgmsButton from "@/components/GgmsButton.vue"
import GgmsInput from "@/components/GgmsInput.vue"
import ProfilePicture from "@/components/ProfilePicture.vue"
import ArrowDown from "@/components/icons/ArrowDown.vue"
import ListIcon from "@/components/icons/ListIcon.vue"
import { DistributionType, LeadDistributionNodeType } from "@/shared/models/workflow"


export default /*#__PURE__*/_defineComponent({
  __name: 'LeadDistributionComponent',
  setup(__props) {

const workflowStore = useWorkflowStore()
const agentsStore = useAgentsStore()
const collectionStore = useCollectionStore()

const distributionOptions = ref([
    { displayName: "Sequential", value: DistributionType.sequential },
    { displayName: "Random", value: DistributionType.random },
    { displayName: "Round robin", value: DistributionType.round },
    { displayName: "First to claim", value: DistributionType.first },
])
const searchString = ref("")
const isTypeModalOpen = ref(false)
const isSearching = ref(false)
const data = ref<Agent[] | Collection[]>([])
const searchMenu = ref()
const typeMenu = ref()
const isAllSelected = ref(false)
const total = ref(0)
const showData = ref(false)

const selectionTitle = computed(() =>
    workflowStore.modelValue.value === LeadDistributionNodeType.agent ? "Specific agent/s" : "List/s of agents"
)
const selectionDescription = computed(() =>
    workflowStore.modelValue.value === LeadDistributionNodeType.agent ? "agent/s" : "list/s of agents"
)
const selectAllText = computed(() => (isAllSelected.value ? "Deselect all" : `Select all (${total.value})`))

async function getAgents() {
    data.value = await agentsStore.getAgents(searchString.value)
}

function isElementChecked(element: Agent | Collection) {
    return !!workflowStore.selectedData.find((el) => el._id === element._id)
}

async function getCollections() {
    data.value = await collectionStore.searchCollections(searchString.value, "agent")
}

function toggleSearchMenu(event?: Event) {
    searchMenu.value.show(event)
}

function toggleTypeMenu(event?: Event) {
    if (isTypeModalOpen.value) {
        typeMenu.value.hide()
        isTypeModalOpen.value = false
    } else {
        typeMenu.value.show(event)
        isTypeModalOpen.value = true
    }
}

function closeSearchMenu() {
    showData.value = true
    searchMenu.value.hide()
    if (workflowStore.modelValue.event) {
        workflowStore.areButtonDisabled = false
    }
}

function onSelect() {
    if (isAllSelected.value) {
        clearSelectedData()
    } else {
        workflowStore.selectedData = data.value
    }
    isAllSelected.value = !isAllSelected.value
}

async function selectType(type: string) {
    workflowStore.modelValue.value = type
    typeMenu.value.hide()
    isTypeModalOpen.value = false
    clearSelectedData()
    type === LeadDistributionNodeType.agent ? await getAgents() : await getCollections()
    total.value = data.value.length
}

function deleteData(element: Agent | Collection) {
    workflowStore.selectedData.splice(workflowStore.selectedData.indexOf(element), 1)
}

function clearSelectedData() {
    workflowStore.selectedData = []
}

function onClick(element: Agent | Collection) {
    if (isElementChecked(element)) {
        const index = workflowStore.selectedData.findIndex((el) => el._id === element._id)
        workflowStore.selectedData.splice(index, 1)
        return
    }

    workflowStore.selectedData.push(element)
}

watch(
    () => searchString.value,
    debounce(async () => {
        isSearching.value = true
        workflowStore.modelValue.value === LeadDistributionNodeType.agent ? await getAgents() : await getCollections()
        isSearching.value = false
    }, 250)
)

watch(
    () => typeMenu.value?.visible,
    () => {
        isTypeModalOpen.value = typeMenu.value.visible
    }
)

watch(
    () => workflowStore.modelValue.event,
    () => {
        if (showData.value) {
            workflowStore.areButtonDisabled = false
        }
    }
)

watch(
    () => workflowStore.selectedData.length,
    () => {
        if (!workflowStore.selectedData.length) {
            workflowStore.areButtonDisabled = true
            return
        }
        workflowStore.areButtonDisabled = false
    }
)

onMounted(async () => {
    if (workflowStore.selectedData.length) {
        showData.value = true
    }
    workflowStore.modelValue.value === LeadDistributionNodeType.agent ? await getAgents() : await getCollections()
    total.value = data.value.length
})

return (_ctx: any,_cache: any) => {
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(GgmsRadioSelect, {
      modelValue: _unref(workflowStore).modelValue.event,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(workflowStore).modelValue.event) = $event)),
      label: "Distribution mechanic",
      options: distributionOptions.value
    }, null, 8, ["modelValue", "options"]),
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", {
        class: "flex justify-center items-center gap-x-2 cursor-pointer w-fit",
        onClick: toggleTypeMenu
      }, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(selectionTitle.value), 1),
        _createElementVNode("div", null, [
          _withDirectives(_createVNode(ArrowDown, { class: "rotate-180 fill-gray-700" }, null, 512), [
            [_vShow, isTypeModalOpen.value]
          ]),
          _withDirectives(_createVNode(ArrowDown, { class: "fill-gray-700" }, null, 512), [
            [_vShow, !isTypeModalOpen.value]
          ])
        ])
      ]),
      _createVNode(_component_OverlayPanel, {
        ref_key: "typeMenu",
        ref: typeMenu,
        appendTo: "#specificTypeDropdown",
        class: "bg-white rounded-md !left-0 ring-1 ring-black ring-opacity-5 shadow-lg mx-6 right-1 w-64 top-0"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (selectType('agent')))
              }, "Specific agent/s"),
              (_unref(workflowStore).modelValue.value === 'agent')
                ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                    key: 0,
                    class: "w-4 h-4"
                  }))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (selectType('list')))
              }, "List/s agents"),
              (_unref(workflowStore).modelValue.value === 'list')
                ? (_openBlock(), _createBlock(_unref(CheckIcon), {
                    key: 0,
                    class: "w-4 h-4"
                  }))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _: 1
      }, 512)
    ]),
    _createElementVNode("p", _hoisted_8, " Assign enrolled leads to the selected " + _toDisplayString(selectionDescription.value) + ". ", 1),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(GgmsInput, {
        modelValue: searchString.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((searchString).value = $event)),
        class: "w-full mt-4",
        iconStart: _unref(SearchIcon),
        placeholder: "Search",
        onInput: toggleSearchMenu,
        onClick: toggleSearchMenu
      }, null, 8, ["modelValue", "iconStart"]),
      _createVNode(_component_OverlayPanel, {
        ref_key: "searchMenu",
        ref: searchMenu,
        class: "!left-0 ring-1 ring-black ring-opacity-5 shadow-lg rounded-md bg-white mx-6 right-1",
        appendTo: "#searchOverlayTarget"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              (!data.value?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, "No results found"))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(data.value, (element) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: element._id,
                      class: "flex items-center gap-x-2 px-4 py-3 cursor-pointer border-b border-gray-200 last:border-0",
                      tabindex: "0"
                    }, [
                      _createVNode(GgmsCheckBox, {
                        checked: isElementChecked(element),
                        onClick: ($event: any) => (onClick(element))
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_13, [
                            (_unref(workflowStore).modelValue.value === 'agent')
                              ? (_openBlock(), _createBlock(ProfilePicture, {
                                  key: 0,
                                  image: element?.profilePicture,
                                  fullName: element?.fullName
                                }, null, 8, ["image", "fullName"]))
                              : (_openBlock(), _createBlock(ListIcon, { key: 1 })),
                            _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(workflowStore).modelValue.value === _unref(LeadDistributionNodeType).agent
                                                    ? element?.fullName
                                                    : element?.displayName), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["checked", "onClick"])
                    ]))
                  }), 128)),
              (isSearching.value)
                ? (_openBlock(), _createBlock(GgmsLoading, { key: 2 }))
                : _createCommentVNode("", true)
            ])
          ]),
          (_unref(workflowStore).selectedData.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createElementVNode("div", {
                    class: "bg-gray-300 w-4 h-4 rounded-sm cursor-pointer",
                    onClick: clearSelectedData
                  }, [
                    _createVNode(_unref(MinusSmIcon), { class: "w-4 h-4" })
                  ]),
                  _createElementVNode("p", _hoisted_17, [
                    _createTextVNode(_toDisplayString(_unref(workflowStore).selectedData.length) + " selected - ", 1),
                    _createElementVNode("span", {
                      class: "font-medium text-primary-color-600 hover:text-primary-color-500 cursor-pointer",
                      onClick: onSelect
                    }, _toDisplayString(selectAllText.value), 1)
                  ])
                ]),
                _createVNode(GgmsButton, { onClick: closeSearchMenu }, {
                  default: _withCtx(() => [
                    _createTextVNode("Done")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 512),
      (showData.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(workflowStore).selectedData, (data) => {
              return (_openBlock(), _createElementBlock("div", {
                key: data._id,
                class: "flex justify-between items-center border-b border-gray-200 last:border-0 py-2.5 px-2"
              }, [
                _createElementVNode("div", _hoisted_19, [
                  (_unref(workflowStore).modelValue.value === 'agent')
                    ? (_openBlock(), _createBlock(ProfilePicture, {
                        key: 0,
                        image: data?.profilePicture,
                        fullName: data?.fullName
                      }, null, 8, ["image", "fullName"]))
                    : (_openBlock(), _createBlock(ListIcon, { key: 1 })),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(workflowStore).modelValue.value === _unref(LeadDistributionNodeType).agent
                                    ? data?.fullName
                                    : data?.displayName), 1)
                ]),
                _createVNode(_unref(TrashIcon), {
                  class: "x-5 h-5 m-1 cursor-pointer",
                  onClick: ($event: any) => (deleteData(data))
                }, null, 8, ["onClick"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})